module.exports = __webpack_public_path__ + "cf98060490cc7b602e35351b30793393.ttf";


//////////////////
// WEBPACK FOOTER
// ./client/Site/Style/fonts/geo-webfont/geo-regular.ttf
// module id = 90
// module chunks = 0